(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart_faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[id^="SmartFaq-"]').forEach(root => {
    if (root.dataset.ready) return; root.dataset.ready='1';
    const input=root.querySelector('[data-faq-search]');
    const clear=root.querySelector('[data-clear-search]');
    const items=[...root.querySelectorAll('.sf__item')];
    const filters=[...root.querySelectorAll('[data-cat]')];
    const chips=[...root.querySelectorAll('[data-search-chip]')];
    const count=root.querySelector('.sf__count b');
    const empty=root.querySelector('[data-empty]');
    const recs=[...root.querySelectorAll('[data-rec]')];
    let cat='all';
    const norm=s => (s||'').toLocaleLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9äöüßà-ÿąćęłńóśźżčďěňřšťůýž\s-]/gi,' ').replace(/\s+/g,' ').trim();
    const updateRecs=visible => {
      const scores={};
      visible.forEach(el => (el.dataset.recs||'').split(',').forEach(id => scores[id]=(scores[id]||0)+1));
      recs.forEach((r,i)=>{r.classList.remove('is-suggested');r.style.order='10';});
      Object.entries(scores).sort((a,b)=>b[1]-a[1]).slice(0,4).forEach(([id],i)=>{const r=recs.find(x=>x.dataset.rec===id);if(r){r.classList.add('is-suggested');r.style.order=String(i);}});
    };
    const run=()=>{
      const q=norm(input.value); let visible=[];
      items.forEach(el=>{const hitCat=cat==='all'||el.dataset.category===cat; const hitText=!q||norm(el.textContent).includes(q); const show=hitCat&&hitText; el.hidden=!show; if(show) visible.push(el);});
      count.textContent=String(visible.length); empty.hidden=visible.length!==0; updateRecs(visible);
      if(q.length>=3 && visible.length){items.forEach(x=>{if(x.dataset.autoOpen==='1'){x.open=false;x.dataset.autoOpen='0';}}); const first=visible[0]; if(!first.open){first.open=true;first.dataset.autoOpen='1';}}
    };
    input.addEventListener('input',run); clear.addEventListener('click',()=>{input.value='';input.focus();run();});
    filters.forEach(btn=>btn.addEventListener('click',()=>{cat=btn.dataset.cat;filters.forEach(b=>{const on=b===btn;b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',String(on));});run();}));
    chips.forEach(btn=>btn.addEventListener('click',()=>{input.value=btn.dataset.searchChip;input.focus();run();}));
    run();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
